import React, {Component} from 'react';
import Axios from 'axios';
import connect from "react-redux/es/connect/connect";
import moment from "moment";
import getConfig from "./config/config";
import Error from "./Error";
import Downloader from 'js-file-downloader'
import lodash from 'lodash';

const LATEST_PLAYBACK_TIME_KEY = 'cpm_player_latest_playback_time';

class SharedVideoDetail extends Component {
    constructor (props) {
        super (props);

        this.state = {
            name:"",
            playVideoMediaFormat:"",
            thumbnailUrl:"",
            description:"",
            videoUrl:"",
            downloadUrl: "",
            downloadUrlForDisplay: "",
            playUrl:"",
            jobId:"",
            fullscreen: false
        };

        this.state.videoId = this.props.location && this.props.location.search && this.deparam(this.props.location.search).v;
        this.state.configurationId = this.props.location && this.props.location.search && this.deparam(this.props.location.search).c;
    }

    componentDidMount = async () => {
        try {
            await this.setInitialState();

            let latestPlaybackTime = 0;
            let playerThemeSetting = {};
            
            //타임 라인 보일지 여부
            if (this.state.configuration.showsControlBar) {
                playerThemeSetting = {
                    controlBar : {
                        progressControl: {},
                    }
                };
            } else {
                playerThemeSetting = {
                    controlBar : {
                        playToggle: false,
                        fullscreenToggle: false,
                        pictureInPictureToggle: false,
                        progressControl: false,
                        cloudplexSettingsButton: {
                            menu: { title: "Settings" },
                            defaultOptions: [],
                            closeButton: true,
                            items: [
                            "subsCapsButton",
                            //"playbackRateMenuButton",
                            "qualityLevelButton",
                            "audioTrackButton",
                            "cloudplexChapterButton",
                            "cloudplexDescription",
                            ],
                        }
                    },
                    bigControlPanelOptions: {
                        replay: false,
                        gesture: false,
                        sectionCrossButton: false,
                        controls:false
                    },
                    hotkey: {
                        custom: {
                          left: null,
                          right: null,
                          space: null,
                          k: null
                        }
                    }
                };
            };

            var player = window.player = window.CloudPlexPlayer('cloudplex-media-player',
            {
                ...playerThemeSetting,
                crossOrigin: 'anonymous',
                theme: 'default',
                muted: true,
                autoplay: true                
            });

            //이어서 재생할지 여부
            if (this.state.configuration.allowsContinuesPlaying) {
                latestPlaybackTime = this.getLatestPlaybackTime();
                console.log("like live latestPlaybackTime: ", latestPlaybackTime);
                // if (process.env.REACT_APP_NOT_SECRET_CODE === 'atomy'){
                //     //생방송 처럼 보이기 (애터미 한정)
                //     latestPlaybackTime = this.getLatestPlaybackTime();
                //     console.log("like live latestPlaybackTime: ", latestPlaybackTime);                
                // }
                // else {
                //     //이어보기
                //     latestPlaybackTime = localStorage.getItem(`${LATEST_PLAYBACK_TIME_KEY}_${this.state.configuration.id}`);
                //     console.log("latestPlaybackTime: ", latestPlaybackTime);
                // }
            }

            player.on("timeupdate", () => {
                localStorage.setItem(`${LATEST_PLAYBACK_TIME_KEY}_${this.state.configuration.id}`, player.currentTime());
            });

            player.on("ended", () => {
                player.reset();
            });

            player.ready(()=>{
                player.player.controlBar.playToggle.on("click", () => {
                    console.log("---- play controlBar.playToggle ---- player.paused(): ", player.paused());
                    if (!player.paused() && this.state.configuration.allowsContinuesPlaying)
                        player.currentTime(this.getLatestPlaybackTime());
                });
    
                player.player.BigControlPanelPlugin().bigControlPanel.controlPannel.playButton.on("click", () => {
                    console.log("---- play bigControlPanelPlugin---- player.paused(): ", player.paused());
                    if (!player.paused() && this.state.configuration.allowsContinuesPlaying)
                        player.currentTime(this.getLatestPlaybackTime());
                });
            });


            player.on('loadedmetadata', () => {
                player.currentTime(latestPlaybackTime);
                player.volume(0.5);

                console.log("this.state.captions: ", this.state.captions);
                
                this.state.captions && this.state.captions.forEach(c => {
                    let captionTrack = {
                        id: c.label,
                        kind: "subtitles",
                        label: c.label,
                        language: c.language,
                        src: c.url
                    };
    
                    console.log("captionTrack: ", captionTrack);
    
                    if(c.isPreferred && c.isPreferred === true)
                        captionTrack.mode = 'showing';
    
                    player.addTextTrack(captionTrack, true);
                });
              });

            player.src([{
                src: this.state.playUrl,
                type: this.state.mimeType,
                thumbnail: this.state.thumbnailUrl,
                meta: {
                    "video-id": this.state.videoId
                },
                descriptionDetail: {
                    title: this.state.name,
                    content: this.state.description,
                },
                title: this.state.name,
                subTitle: this.state.subtitle,
                description: this.state.description,
                poster: this.state.thumbnailUrl,
            }]);
            
        } catch (e) {
            const error = {
                status : e.status,
                message : e
            }

            console.log("error : ", e);

            this.setState({
                error
            });
        }
    }

    deparam = (search) => {
        if(!search || search.trim().length === 0) {
            return null;
        }

        if(search.indexOf('?') === 0) {
            search = search.slice(1);
        }

        const params = search.split('&');
        if(params.length === 0) {
            return null;
        }

        const result = {};
        params.forEach(p => {
            const param = p.split('=');

            result[param[0]] = param[1];
        });

        return result;
    };

    getLatestPlaybackTime = () => {
        const current = moment.utc();
        const startAt = !lodash.isEmpty(this.state.configuration.startAt) ? moment.utc(this.state.configuration.startAt) : moment.utc(this.state.configuration.createdAt);
        const startPlaybackTime = moment(current).diff(startAt) / 1000;
        console.log("startPlaybackTime: ", startPlaybackTime);
        return startPlaybackTime;
    }

    getUrlFromUrls = (urls) => {
        return Array.isArray(urls) ? urls.length > 0 && urls[0] : urls;
    }

    getConfiguration = async () => {
        try {
            console.debug("getConfiguration configurationId: ", this.state.configurationId);
            
            if (lodash.isEmpty(this.state.configurationId))
                throw "not found video configuration id."

            const response = await Axios.get(`${getConfig().host.api}/videos/${this.state.videoId}/shared/configurations/${this.state.configurationId}?children=full`, {});

            if (lodash.isEmpty(response.data))
                throw "not found video configuration.";

            const configuration = response.data;

            const allowStatus = ['PUBLISHING', 'PUBLISHED'];
            if (!allowStatus.includes(configuration.status))
                throw "not published video."

            const current = moment.utc();
            const startDiff = lodash.isEmpty(configuration.startAt) ? undefined : moment(current).diff(moment.utc(configuration.startAt));
            const endDiff = lodash.isEmpty(configuration.endAt) ? undefined : moment(current).diff(moment.utc(configuration.endAt));

            console.log("current: ", current.format('YYYY-MM-DD HH:mm:ss')); 
            console.log("startDiff: ", startDiff);
            console.log("endDiff: ", endDiff);

            if (startDiff !== undefined && endDiff !== undefined) {
                if ((startDiff < 0 && endDiff < 0)
                    || (startDiff > 0 && endDiff > 0)) {
                    throw "It is not a video release period."
                }
            } else if (startDiff === undefined && endDiff !== undefined) {
                if (endDiff > 0)
                    throw "It is not a video release period."
            } else if (startDiff !== undefined && endDiff === undefined) {
                if (startDiff < 0)
                    throw "It is not a video release period."
            }
            return response.data;

        } catch (e) {
            console.debug("getConfiguration error :", e);
            throw e;
        }
    }

    getVideoAsync = async (projectId) => {
        try {
            if (this.state.videoId === undefined) {
                throw "not found video id."
            }

            const response = await Axios.get(`${getConfig().host.api}/videos/${this.state.videoId}/shared/`, {
                params:{
                    children: "metadataschemas,posters,captions,sources"
                },
                headers:{
                    "projectId":projectId
                }
            });

            console.log("getVideo response: ", response);

            if (!response.data)
                return null;

            const video = response.data;

            let playUrl = '';
            let playVideoMediaFormat = '';
            let downloadUrl = '';

            if(video && video.sources && video.sources.length > 0) {
                video.sources.forEach(source => {
                    // 비디오 소스에 mp4 가 있는지 확인
                    if (source.type === 'MP4') {
                        downloadUrl = source.urls && this.getUrlFromUrls(source.urls);
                    } else {
                        // MP4가 아닌 것 중에 첫번째거 넣기
                        if (!playUrl) {
                            playUrl = source.urls && this.getUrlFromUrls(source.urls);
                            // playUrl = source.accessUrls && this.getUrlFromUrls(source.accessUrls);
                            // playUrl = source.originalUrls && this.getUrlFromUrls(source.originalUrls);
                            playVideoMediaFormat = source.type && source.type.toLowerCase();
                        }
                    }
                });
            }

            // downloadUrl 이 비어 있다면 비디오 소스에 MP4 파일이 없는 것이므로 오리진에서 찾아 봄
            if (downloadUrl === '') {
                if (video.origins && video.origins.length > 0) {
                    video.origins.forEach(origin => {
                        if (origin.type === 'MP4') {
                            downloadUrl = origin.originalUrls && this.getUrlFromUrls(origin.originalUrls);
                        }
                    });
                }
            }

            let captions = [];
            if (video.captions && video.captions.length > 0) {
            captions = video.captions.reduce((acc, c) => {
                    if (c.elements) {
                        return acc.concat(c.elements);
                    }
                },
                []);
              }

            return {
                id : video.id,
                name : video.name,
                description : video.description === null || video.description === 'undefined' ? "" : video.description,
                playVideoMediaFormat,
                playUrl,
                downloadUrl,
                thumbnailUrl : video.primaryPoster && video.primaryPoster.url,
                jobId : video.job && video.job.id,
                duration : video.duration,
                categories: video.categories,
                captions,
                attributions: video.attributions,
                tags: video.tags,
                people: video.people,
                metadatas: video.metadataSchemas
            };
        } catch(e) {
            console.debug("error-feel :", e);
            throw e;
        }
    }

    setInitialState = async () => {
        try {
            const configuration =  await this.getConfiguration();

            console.log("setInitialState configuration: ", configuration);

            const video =  await this.getVideoAsync(configuration.project.id);

            console.debug("video: ", video);

            let mimeType = '';
            switch((video.playVideoMediaFormat || '')) {
                case 'hls':
                    mimeType = 'application/x-mpegURL';
                    break;
                case 'dash':
                    mimeType = 'application/dash+xml';
                    break;
                case 'mp4':
                    mimeType = 'video/mp4';
                    break;
                case 'ts':
                    mimeType = 'video/MP2T';
                    break;
                case 'mp3':
                    mimeType = 'audio/mp3';
                    break;
                default:
                    break;
            }

            this.setState( {
                ...video,
                mimeType,
                configuration: {
                    ...configuration
                },
                subtitle: this.convertPublishingPeriodToString(configuration.startAt, configuration.endAt)
            })
        } catch(e) {
           throw e;
        }
    }

    convertPublishingPeriodToString = (startAt, endAt) => {
        if (lodash.isEmpty(startAt) && lodash.isEmpty(endAt))
            return '모든 기간 시청 가능';
        else if (startAt !== undefined && endAt !== undefined)
            return `시청 기간: ${this.toLocalTime(startAt)} ~ ${this.toLocalTime(endAt)}`;
    }

    toLocalTime = (date) => {
        return moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss');
    }

    formatDuration = (milliseconds, timeFormat) => {
        if(!milliseconds) {
            return '00:00:00';
        }

        if (!timeFormat) {
            timeFormat = 'HH:mm:ss';
        }
        return moment.utc(milliseconds).format(timeFormat);
    };

    download = async (url) => {
        console.debug("this.state.name: ", this.state.name);
        const filename = this.state.name + ".mp4";
        const downloading = new Downloader({
            url,
            filename,
            timeout: 60 * 60 * 1000 ,
            autoStart: true,
            process: (event) => {
                console.debug("download percent : ", Math.floor(event.loaded / event.total * 100) );
            }
        });

        await downloading;
    }

    render = () => {
        return (
            <React.Fragment>

            <div className={`popup popup-player ${this.state.configuration && this.state.configuration.allowsFullscreen ? 'popup-player-fullscreen':''}`}>
            {this.state.error ?
                <Error
                    error = {this.state.error}/>
            :
                <div id='sharedVideoDetail' className="popup-contents" >
                    <div className="popup-video">
                        <div className="vjs-player">
                            <video id="cloudplex-media-player" className="video-js" controls></video>
                        </div>
                    </div>
                    {this.state.configuration && !this.state.configuration.allowsFullscreen &&
                        <div className="popup-body">
                            <div className="popup-title">
                                <div className='popup-title-article1' >
                                    <i className='sprite sprite-video'/>
                                    <h1>{this.state && this.state.name}</h1>
                                </div>
                                <div>
                                    {this.state.configuration
                                    && this.state.configuration.allowsDownloading &&
                                        <button className="btn btn-outline-light btn-icon btn-download"
                                            style={{width: 30 +'px', height: 30 +'px'}}
                                            data-tooltip={"download"}
                                            disabled={this.state.downloadUrl === ''}
                                            onClick={(e) => {
                                                this.download(this.state.downloadUrl);
                                            }}>
                                            <i className={"sprite sprite-download"}>
                                            </i>
                                        </button>
                                    }
                                </div>
                            </div>

                            <div className='box-scroll'>
                                <div className="list-overview">
                                    <ul>
                                        <li>
                                            <strong className="title">Duration</strong>
                                            <div className="content">
                                                {this.formatDuration(this.state && this.state.duration)}
                                            </div>
                                        </li>
                                        <li>
                                            <strong className="title">Description</strong>
                                            <div className="content">
                                                {this.state && this.state.description ?
                                                    <span>{this.state.description}</span>
                                                    :
                                                    <span className={"text-cancel"}>{"None"}</span> }
                                            </div>
                                        </li>
                                        <li>
                                            <strong className="title">Categories</strong>
                                            <div className="content">
                                                {this.state.categories && this.state.categories.length > 0 ?
                                                    this.state.categories.map(v => v.name).join(", ")
                                                    :
                                                    <span className={"text-cancel"}>{"None"}</span>
                                                }
                                            </div>
                                        </li>
                                        <li>
                                            <strong className="title">Attributions</strong>
                                            <div className="content">
                                                {this.state.attributions && this.state.attributions.length > 0 ?
                                                    <div className='list'>
                                                        <ul className="">
                                                            {this.state.attributions.map((a, i) =>
                                                                <li key={i}>
                                                                    <strong>{a.key}</strong> : <span className="text-secondary">{a.value}</span>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                    :
                                                    <span className={"text-cancel"}>{'None'}</span>
                                                }
                                            </div>
                                        </li>
                                        <li>
                                            <strong className="title">Tags</strong>
                                            <div className="content">
                                                <React.Fragment>
                                                {this.state.tags && this.state.tags.length > 0 ?
                                                    <div className={"list-tags"}>
                                                        {this.state.tags.map((t, i) =>
                                                            <span key={`${i}_${t.id}`} className={"tag"}>
                                                                {/* ToDO AI에서 추출된 경우는 class ai 추가 */}
                                                                {t.value}
                                                            </span>
                                                        )}
                                                    </div>
                                                    :
                                                    <span className={"text-cancel"}>None</span>
                                                }
                                                </React.Fragment>

                                            </div>
                                        </li>
                                    </ul>
                                    <hr/>
                                    <ul>
                                        <li>
                                            <strong className="title">People</strong>
                                            <div className="content">
                                            {this.state.people && this.state.people.length > 0 ?
                                                (
                                                    <React.Fragment>
                                                        {this.state.people.map((p, i) =>
                                                            <div key={`people-${i}`} className={"list-people"}>
                                                                <div>
                                                                    <span className={"thumb"}>
                                                                        <img src={p.accessUrl}/>
                                                                    </span>
                                                                    <span className={"text-break"}>{p.name}</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                )
                                                :
                                                (<span className={"text-cancel"}>None</span>)
                                            }
                                            </div>
                                        </li>
                                    </ul>
                                    <hr/>
                                    <ul>
                                        {this.state.metadatas && this.state.metadatas.length > 0 &&  this.state.metadatas.map((v, i) =>
                                            v.fields && v.fields.map((f, k) =>
                                                <li key={`${i}-${k}`}>
                                                    {f.id !== '' ?
                                                        <React.Fragment>
                                                            <strong className="title">{f.name}</strong>
                                                            <div className="content">
                                                                {f.value ? <span>{f.value}</span> : <span className={"text-cancel"}>{"None"}</span> }
                                                            </div>
                                                        </React.Fragment>
                                                        :
                                                        <span className={`${f.value ? '': 'text-cancel'}`}>
                                                            {
                                                                f.value === ''
                                                                    ? "None"
                                                                    : f.value
                                                            }
                                                        </span>
                                                    }
                                                </li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
            </div>

            </React.Fragment>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        state
    };
};

SharedVideoDetail = connect(mapStateToProps)(SharedVideoDetail);
export default SharedVideoDetail;